import { create } from "zustand";

export const useGlobalLoadingStore = create((set) => ({
  loading: false,
  message: "",
  subMessage: "",
  startLoading: (message, subMessage) =>
    set({
      loading: true,
      message: message || "데이터를 불러오고 있습니다",
      subMessage: subMessage || "잠시만 기다려주세요",
    }),
  stopLoading: () => set({ loading: false }),
}));
